// extracted by mini-css-extract-plugin
export default {"buttons":"SaveButtons_buttons__KSxJj"};